import styled from 'styled-components'
import { useEffect, useRef, useState } from 'react'

type SliderProps = {
  range: number[]
  bodyHeight: number
  setBodyHeight: (bodyHeight: number) => void
}

const Slider = ({ range, bodyHeight, setBodyHeight }: SliderProps) => {
  const [labelPosition, setLabelPosition] = useState(0)
  const [dragging, setDragging] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBodyHeight(Number(event.target.value))
    // setLabelPosition(
    //   inputRef.current?.offsetWidth || 0 / 2
    //   // 45 +
    //   //   (((bodyHeight - range[0]) / (range[1] - range[0])) *
    //   //     ((inputRef.current?.offsetWidth || 0) - 5 - 5) -
    //   //     3)
    // )
  }

  useEffect(() => {
    if (bodyHeight < range[0]) {
      setBodyHeight(range[0])
    } else if (bodyHeight > range[1]) {
      setBodyHeight(range[1])
    }
  }, [range])

  // useEffect(() => {
  //   setLabelPosition(
  //     inputRef.current?.offsetWidth || 0 / 2
  //     // 45 +
  //     //   (((bodyHeight - range[0]) / (range[1] - range[0])) *
  //     //     ((inputRef.current?.offsetWidth || 0) - 5 - 5) -
  //     //     3)
  //   )
  // }, [])

  return (
    <SliderContainer>
      <LabelContainer $location={labelPosition} $dragging={dragging}>
        <span>
          <LabelText>
            <b>
              {bodyHeight === range[0]
                ? '<' + bodyHeight
                : bodyHeight === range[1]
                ? '>' + bodyHeight
                : bodyHeight}
            </b>
            <br />
            <small>cm</small>
          </LabelText>
        </span>
      </LabelContainer>
      {/* <div className='slider-text'>
        <b>{bodyHeight}</b>
      </div> */}
      <input
        ref={inputRef}
        type='range'
        min={range[0]}
        max={range[1]}
        value={bodyHeight}
        step='1'
        onChange={handleChange}
        onMouseDown={() => {
          setDragging(true)
        }}
        onMouseUp={() => {
          setDragging(false)
        }}
        onTouchStart={() => {
          setDragging(true)
        }}
        onTouchEnd={() => {
          setDragging(false)
        }}
        style={{ width: '90%' }}
      />
    </SliderContainer>
  )
}
const SliderContainer = styled.div`
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  input {
    --c: var(--text-color); /* active color */
    --g: 8px; /* the gap */
    --l: 5px; /* line thickness*/
    --s: 45px; /* thumb size*/

    /* width: 400px; */
    height: var(--s); /* needed for Firefox*/
    --_c: color-mix(in srgb, var(--c), #000 var(--p, 0%));
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    cursor: pointer;
    overflow: hidden;
  }
  input:focus-visible,
  input:hover {
    --p: 25%;
  }
  input:active,
  input:focus-visible {
    --_b: var(--s);
  }
  /* chromium */
  input[type='range' i]::-webkit-slider-thumb {
    height: var(--s);
    aspect-ratio: 1;
    border-radius: 50%;
    box-shadow: 0 0 0 var(--_b, var(--l)) inset var(--_c);
    border-image: linear-gradient(90deg, var(--_c) 50%, #ababab 0) 0 1 /
      calc(50% - var(--l) / 2) 100vw/0 calc(100vw + var(--g));
    -webkit-appearance: none;
    appearance: none;
    transition: 0.3s;
  }
  /* Firefox */
  input[type='range']::-moz-range-thumb {
    height: var(--s);
    width: var(--s);
    background: none;
    border-radius: 50%;
    box-shadow: 0 0 0 var(--_b, var(--l)) inset var(--_c);
    border-image: linear-gradient(90deg, var(--_c) 50%, #ababab 0) 0 1 /
      calc(50% - var(--l) / 2) 100vw/0 calc(100vw + var(--g));
    -moz-appearance: none;
    appearance: none;
    transition: 0.3s;
  }
  @supports not (color: color-mix(in srgb, red, red)) {
    input {
      --_c: var(--c);
    }
  }
  .slider-text {
    font-size: 0.9em;
    position: relative;
    top: 42px;
    left: -23px;
    z-index: 1;
  }
`

const LabelContainer = styled.div<{ $location?: number; $dragging: boolean }>`
  display: grid;
  align-items: center;
  align-self: center;
  font-size: 0.8em;
  border-radius: 50%;
  /* background-color: ${(props) =>
    props.$dragging ? 'var(--yellow-main)' : ''}; */
  color: ${(props) =>
    props.$dragging ? 'var(--text-color)' : 'var(--text-color)'};
  width: 2.5em;
  height: 2.5em;
  margin: auto;
  /* position: relative; */
  /* left: ${(props) => String(props.$location)}px; */
  top: 5px;
  line-height: 0.9em;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
`

const LabelText = styled.span`
  font-size: 1.1em;
  top: 4px;
  small {
    font-size: 0.7em;
  }
`
export default Slider
